export default "__VITE_ASSET__DbkYt9Vg__"